<template>
<v-container v-resize="onResize" style="padding: 0px; max-width: 100%;">
<div  style="padding: 0px;">

  <v-app-bar dense >
    <v-text-field
      label="Search"
      v-model="search"
      @input="handleSearch"
      flat
      solo-inverted
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
    ></v-text-field>
    <v-spacer />
    <v-toolbar-title >Selected Folder : File ({{args.folder ? args.folder+' : ' : 'None'}}{{args.file ? args.file : 'None'}})</v-toolbar-title>
    
  </v-app-bar>

<v-card id="fBrowser" v-if="rootList != null && !redraw">
    <v-layout >
    <v-flex xs6>
    <v-card-text :style="{height: height ? height : wheight,overflow:'auto'}">
      <v-treeview 
        ref="tree"
        :search="debouncedSearch"
        v-model = "selection"
        :active.sync="active"
        :open.sync="open"
        :items="rootList"
        item-key="id"
        :load-children="loadChildren"
        transition
        dense
        :light="!dark"
        @update:active="updateActive"
        open-all
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="!item.ext">
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
          </v-icon>
          <v-icon v-else :style="{color: getColor(item)}">
            {{ fileTypes[item.ext] == undefined ? 'mdi-file-document-outline' : fileTypes[item.ext]}}
          </v-icon>
        </template>
        <template v-slot:label="{ item}">
          <span :style="{color: getColor(item)}" @click="nameClicked(item)">{{item.name}}</span>
          <span><v-icon v-if="selectedNode != null && selectedNode.id == item.id">
            {{ 'mdi-check-bold' }}
          </v-icon></span>
        </template>
      </v-treeview>
    </v-card-text>
    </v-flex>
    <v-flex xs6>
      <v-card-text :style="{height: height ? height : wheight,overflow:'auto'}">
    <DND 
      v-if="mode != 'write'"
      :notitle='true' 
      :url="args.folder" 
      :baseURL="basePutURL" 
      :subdir="args.folder" 
      server='file' 
      :saveCallback="DNDComplete" 
      :selectedFolder="selectedNode"></DND>
    </v-card-text>
    </v-flex>
    </v-layout>
    <v-footer v-if="mode=='write' || mode=='browse'">
      <v-row align="center">
      <v-text-field hide-details label='Create Folder Under Selected Folder' outlined
      v-model = "selectedSubFolder"></v-text-field>
      <v-btn v-if="(mode == 'write' || mode =='browse')" 
        style = "margin-left: 10px;"
        :disabled="selectedSubFolder == null || selectedSubFolder == '' || args.folder == null" 
        color="blue" justify="center" 
        @click="createFolder">Create<v-icon>mdi-folder-open</v-icon>
      </v-btn>
      <v-spacer />
      <v-text-field 
        v-if="mode == 'write'"
        hide-details 
        :label="selectedNode && selectedNode.isDir ? 'File name to Save As' : 'Overwrite File'"
        outlined
        v-model = "renamedFile"
      >
      </v-text-field>
      <v-btn 
        style = "margin-left: 10px;"
        v-if="mode == 'write'"
        :disabled=" !selectedNode || !renamedFile" 
        color = "green" 
        justify="center" 
        @click="save">Save<v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn v-if="mode == 'read'" color = "green" justify="center" @click="save">Open<v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn style="margin-left: 10px; margin-right: 10px;" v-if="(mode == 'write' || mode =='browse')" :disabled="args.folder == null" color="red" justify="center" @click="remove">Delete<v-icon>mdi-cancel</v-icon>
      </v-btn>
      <v-btn style="margin-left: 10px; margin-right: 10px;" v-if="(mode == 'write' || mode =='browse')" :disabled="args.folder == null" color="green" justify="center" @click="downloadWithAxios">Download<v-icon>mdi-download-box</v-icon>
      </v-btn>
      </v-row>
    </v-footer>
  </v-card>
  </div>
  </v-container>
</template>
<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from 'vuex-pathify'
import ColorHash from "color-hash"
const colorHashLight = new ColorHash({saturation: 0.9, lightness: 0.3})
const colorHashDark = new ColorHash({saturation: 0.4, lightness: 0.7})
import DND from '@/../../coreui/library/DragAndDrop'
export default {
  props:['mode', 'isSuper', 'height'],
  components: {
    DND
  },
  data() {
    return {
      basePutURL: '/files/',
      baseGetURL: '/getfiles/',
      lastheight: 400,
      wheight: 400,
      windowSize: {
        x: 0,
        y: 0
      },
      search: '',
      debouncedSearch: '',
      redraw: false,
      selectedNode: null,
      args: {},
      selection: [],
      updateActive: '',
      root: '',
      server: axiosInstances.fileServer,
      rootOptions: [],
      renamedFile: '',
      selectedSubFolder:null,
      open: [],
      active: [],
      rootList: [],
      // selected: {
      //   id: 0,
      //   items: []
      // },
      id: 0,
      fileTypes: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        jpg: 'mdi-file-image',
        jpeg: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        bin: 'mdi-file-document-outline',
      },
    };
  },
 
  created() {
    // this.getCategoryList(0);
  },
  computed: {
    loggedinUser: sync('login/loggedinUser'),
    origLoggedinUser: sync('login/origLoggedinUser'),
    facility: sync('login/facility'),
    dark: sync('misc/dark')
  },
  watch: {
    isSuper: {
      immediate: true,
      handler (val) {
        if (val == 'no' || this.origLoggedinUser.role != 'super') {
          this.basePutURL = this.basePutURL + this.facility 
          this.baseGetURL = this.baseGetURL + this.facility +'/'
        }
        console.log('baseURLs put/get: ', this.facility, this.basePutURL, this.baseGetURL)
      }
    }
  },
  methods: {
    forceFileDownload(response, title) {
      console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios() {
      let file
      let removingId = this.args.node.id
      let subdir = this.args.folder
      if (this.args.isDir) {
        file = this.args.folder.substring(subdir.length+1, this.args.folder.lastIndexOf('/') + 1)
        subdir = this.args.folder.substring(0, this.args.folder.lastIndexOf('/'))
        // console.log('SUBDIR, FILE: ', subdir, file,subdir.length+1,this.args.folder.lastIndexOf('/'))
      } else {
        file = this.args.file
      }
      let url = this.baseGetURL + (file ? (file) : '') + (subdir != '' ? ('?subdir=' + subdir) : '' )
      console.log('URL: ', url, this.args.file)
      axiosInstances.fileServer.get(url, {
            responseType: "arraybuffer",
          })
        .then((response) => {
          this.forceFileDownload(response, file)
        })
        .catch(() => console.log('error occured'))
    },
    async createFolder() {
      let folder = this.selectedSubFolder
      let subdir = this.args.folder
      let url =  this.basePutURL  + '?subdir=' + (subdir != '' ? subdir : '') + '/' + folder
      console.log('URL: ', url)
      console.log(await axiosInstances.fileServer.get(url))
      this.selectedSubFolder = null
      this.refreshNode(this.args.node)
    },

    DNDComplete () {
      this.refreshNode(this.args.node)
    },

    setDefaultRoot() {
      this.rootList = [
        {
          "id": '/',
          "name": '/', 
          "icon": "",
          "isParent": 1,
          "children": [],
          "isDir" : true
        }
      ]
    },

    handleSearch(input) {
      // console.log(input)
      clearTimeout(this.debounce);
      let self = this;
      self.debounce = setTimeout(() => {
        if (input) {
          self.$refs.tree.updateAll(true)
          self.debouncedSearch = input
        } else {
          // self.debouncedSearch = input
        }
      }, 1000);
    },

    getColor(node) {
      if (!node) return
      let color
      if (node.isDir == 1) {
        if (this.dark) {
          color = '#00ff00'
        } else {
          color = '#0000ff'
        }
        return color
      }
      let ext = node.name.split(".")[1] 
      if (this.dark) {
        color = ext != undefined ? colorHashDark.hex(ext) : '#00ff00'
      } else {
        color = ext != undefined ? colorHashLight.hex(ext) : '#0000ff'
      }
      return color
    },

    close () {
      // console.log('closing')
      this.$emit('update:show', false)
    },

    save() {  
      this.elog('trace','Opening file {} (mode = {})', this.args, this.mode)
      let args = {}
      args.folder = this.args.folder
      args.subFolder = this.selectedSubFolder
      args.basePutURL = this.basePutURL
      args.file = this.renamedFile
      this.$emit('update:save', args)
      this.close()
    },

    async remove() {  
      let file
      let removingId = this.args.node.id
      let subdir = this.args.folder
      if (this.args.isDir) {
        file = this.args.folder.substring(subdir.length+1, this.args.folder.lastIndexOf('/') + 1)
        subdir = this.args.folder.substring(0, this.args.folder.lastIndexOf('/'))
        // console.log('SUBDIR, FILE: ', subdir, file,subdir.length+1,this.args.folder.lastIndexOf('/'))
      } else {
        file = this.args.file
      }
      let url = this.baseGetURL + (file ? (file) : '') + (subdir != '' ? ('?subdir=' + subdir) : '' )
      console.log('URL: ', url, this.args.file)
      let self = this
      if ( this.args.children != undefined && this.args.children.length > 0) {
        this.$root
        .$confirm(
          "Directory not empty",
          "You can only delete an empty folder. Please delete contents before deleting directory.",
          {
            color: "red",
            ok: 'OK',
            nocancel: true,
            width: 500

          }
        )
        .then(async function (confirm) {
          if (confirm) {
            // console.log('FileBrowser: 319- Delete file:',url)
            // let res = await axiosInstances.fileServer.delete(url)
            // if (res.status == 200) {
            //   console.log('arg is: ', this.args)
            //   this.refreshNode(this.args.node.parent)
            // }
          } else {
            // console.log("Confirm dialog failed");
          }
        }
      )} else {
        // console.log('FileBrowser: 334- Delete file:',url)
        let res = await axiosInstances.fileServer.delete(url)
        if (res.status == 200) {
          // console.log('arg is: ', this.args)
          this.refreshNode(this.args.node.parent)
        }
      }
    },

    refreshNode(node) {
      let id = node.id
      node.children = []
      let newopen = this.open.filter(e => e !== id)
      this.loadChildren(node)
      newopen.push(id)
      this.open = newopen
    },

    nameClicked(node) {
      this.selectedNode = node
      // console.log('node, open is: ', node, this.open)
      if (node.isDir) {
        this.renamedFile = null
        this.args = {
            root: this.root,
            folder: node.id, 
            file: '', 
            isDir: true,
            children: node.children,
            node: node
          }
      } else {
        this.renamedFile = node.name
        this.args = {
            root: this.root,
            folder: node.id.substring(0, node.id.indexOf(node.name)-1), 
            file: node.name,
            isDir: false,
            children: node.children,
            node: node,
            url: this.baseGetURL
          }
        if (this.mode == 'read' || this.mode == 'browse') this.$emit('update:selected', this.args)
      }
    },
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.y != this.lastheight) {
        this.wheight = (this.windowSize.y - 200)+ 'px'
        this.lastheight = this.height
      }
    },
    // Lazy loading of files and dirs
    async loadChildren(item) {
      // console.log('rootDir: ', this.rootDir, this.root)
      // console.log('LoadChildren: ',item, this.rootDir)
      let self = this
      let url = this.baseGetURL +
        "?type=dir" + (item.id.length != 0 ? ('&subdir='+item.id) : '')
      // console.log ('opening item: (loadchildren)', item, this.root, url)
      let resp = await this.server.get(url)
      let citems = []
      if (resp.status == 200) {
        console.log('resp.data is: ', resp.data)
        if (resp.data != null && resp.data.length > 0) resp.data.forEach(el => {
          citems.push({
            children: [],
            parent: item,
            name: el,
            isDir: true,
            id: item.id + '/' + el // self.id++
          })
        });
      } else {
        // console.log(resp.status, resp.data)
      }
      let furl = this.baseGetURL + "?type=file" + (item.id.length != 0 ? ('&subdir='+item.id) : '')
      // console.log('getting files: ', furl)
      let fl = await self.server.get(furl)
      if (fl.data) fl.data.forEach(fl => {
        let extension = fl.split('.').pop()
        citems.push({parent: item, name: fl, ext: extension ? extension : 'txt', id: item.id + '/' + fl})
      })
      item.children.push(...citems);
    },
    namemap (val) {
      return val
    }
  },
  mounted () {
    this.setDefaultRoot()
    this.onResize()
    this.elog('trace','starting directory: {}, role: {}, org: {}, mode: {}', 
    this.baseURL, this.loggedinUser.role, this.loggedinUser.org, this.mode)()
  }
}
</script>
<style scoped>
html {
  overflow: hidden !important;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>